export const ProviderAppSessionCommon = {
  key: 'appSession',
}

export type ProviderSessionAccountType = null
